import SkillItem from "../skills/SkillItem";

export default function SkillCategory({ category }) {
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-emerald-200 text-center mb-4 pb-2 border-b border-emerald-400/20">
        {category.title}
      </h3>
      
      <div className="space-y-2">
        {category.skills.map((skill, skillIndex) => (
          <SkillItem 
            key={skillIndex} 
            skill={skill} 
          />
        ))}
      </div>
    </div>
  );
}